export enum StripeCouponType {
  ONCE = "once",
  REPEATING = "repeating",
  FOREVER = "forever",
}

export interface StripeSubscriptionCouponDTO {
  name: string;
  percent_off: number; // discount in percentage
  duration_in_months: number; // duration_in_months only for repeating
  duration: StripeCouponType; // type of coupon
  redeem_by: number; // timestamp to when you can use coupon
  max_redemptions: number; // max useage. you can set it on coupon or promotion code
  amount_off: number; // discount in currency
  companyId: string;
}
